"use client"

// src/index.tsx
import React from "react";
import { forwardRef } from "@welcome-ui/system";

// src/styles.ts
import styled, { css, system } from "@xstyled/styled-components";
var iconSvgStrokedStyles = css`
  g,
  path {
    stroke: inherit;
    fill: none;
  }
`;
var iconSvgFilledStyles = css`
  g,
  path {
    stroke: none;
  }
`;
var Icon = styled("svg")(({ isFlag, size = "md", stroked, theme }) => {
  const formattedSize = theme.icons[size] || size;
  return css`
    ${!isFlag && (stroked ? iconSvgStrokedStyles : iconSvgFilledStyles)};
    width: ${formattedSize};
    height: ${formattedSize};
    ${system};
  `;
});

// src/index.tsx
var Icon2 = forwardRef(
  ({ content, dataTestId, size = "md", title, ...props }, ref) => {
    const className = props.className || "";
    if (!content) {
      return null;
    }
    return /* @__PURE__ */ React.createElement(
      Icon,
      {
        alt: title,
        dangerouslySetInnerHTML: { __html: content.block },
        "data-testid": dataTestId && `icon-${dataTestId}`,
        isFlag: content.isFlag,
        ref,
        role: "img",
        size,
        stroked: content.stroked,
        title,
        viewBox: content.viewBox || "0 0 100 100",
        ...props,
        className: `${className} wui-icon`
      }
    );
  }
);
Icon2.displayName = "Icon";
var StyledIcon = Icon;
export {
  Icon2 as Icon,
  StyledIcon
};
